import { configureStore } from "@reduxjs/toolkit";

import { rtkQueryErrorLogger } from "utils";
import appConfigReducer from "./configSlice";
import { neftApi } from "./config";

import auditReducer from "pages/Audit/auditSlice";
import reportReducer from "pages/Report/reportSlice";
import reprocessReducer from "pages/Reprocess/reprocessSlice";
import generationReducer from "pages/Generation/generationSlice";
import tPlusOneProcessingReducer from "pages/TPlusOneProcessing/tPlusOneProcessingSlice";

const store = configureStore({
  reducer: {
    audit: auditReducer,
    report: reportReducer,
    reprocess: reprocessReducer,
    generation: generationReducer,
    configuration: appConfigReducer,
    tPlusOneProcessing: tPlusOneProcessingReducer,
    [neftApi.reducerPath]: neftApi.reducer,
  },
  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware({ thunk: true, serializableCheck: false }).concat(
      rtkQueryErrorLogger,
      neftApi.middleware,
    ),
  devTools: process.env.NODE_ENV !== "production",
});

export default store;

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
